import { Interpolation, Theme, css } from '@emotion/react'

export const container: Interpolation<Theme> = (theme) => css`
  --toastify-font-family: 'Plus Jakarta Sans', sans-serif;
  --toastify-text-color-light: ${theme.colors.typographyTwo};
  --toastify-icon-color-success: ${theme.colors.green};
  --toastify-icon-color-error: ${theme.colors.red};

  font-weight: 500;
  font-size: 1rem;
  line-height: 1.5;
`
